import { render, staticRenderFns } from "./ModalChangeAvatar.vue?vue&type=template&id=5a53cdd2&scoped=true&"
import script from "./ModalChangeAvatar.vue?vue&type=script&lang=js&"
export * from "./ModalChangeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeAvatar.vue?vue&type=style&index=0&id=5a53cdd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53cdd2",
  null
  
)

export default component.exports